export const STRIPE_CONFIG = {
  publishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  productId: 'prod_RgOo4ot8R9C2aX',
  priceId: 'price_1Qn219An2DhdXXyrLo8zISIW',
  successUrl: `${window.location.origin}/profile?session_id={CHECKOUT_SESSION_ID}`,
  cancelUrl: `${window.location.origin}/subscription`,
  mode: 'subscription'
};